import Navbar from './Navbar';
import Footer from './Footer';
import StickyMobileCTA from './StickyMobileCTA';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export default function Layout({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'auto' : 'auto' });
  }, [pathname]);
  return (
    <div className="relative min-h-screen bg-[#07111F] text-white">
      <Navbar />
      <main className="relative">{children}</main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
